<template>
  <div class="rokka-uploader upload">
    <table v-if="filesPrincipal.length">
      <tr v-for="file in filesPrincipal" :key="file.id">
        <td class="remove">
          <button
            type="button"
            class="removeButton"
            @click.prevent="removeImage(file)"
          >
            x
          </button>
        </td>
        <td class="thumb">
          <img v-if="file.thumb" :src="file.thumb" />
          <span v-else>No Image</span>
        </td>
        <td>{{ file.name }}</td>
        <td>{{ formatSize(file.size) }}</td>
        <br />
        <td v-if="file.error">{{ file.error }}</td>
        <td v-else-if="file.success">Uploaded</td>
        <td v-else-if="file.active">Uploading</td>
        <td v-else>To upload</td>
      </tr>
    </table>

    <div v-else>
      <div class="text-center p-5">
        <h4>Drop files anywhere to upload</h4>
      </div>
    </div>

    <div
      v-show="$refs.uploadPrincipal && $refs.uploadPrincipal.dropActive"
      class="drop-active"
    >
      <h3>Drop files to upload</h3>
    </div>

    <div class="rokka-upload-component">
      <vue-upload-component
        ref="uploadPrincipal"
        input-id="filesPrincipal"
        v-model="filesPrincipal"
        :post-action="logotipoAPI"
        class="rokka-fileupload"
        extensions="gif,jpg,jpeg,png,webp"
        accept="image/png, image/gif, image/jpeg, image/webp"
        :size="1024 * 1024 * 10"
        :multiple="false"
        :drop="true"
        @input-filter="inputFilter"
        @input-file="inputFile"
      >
        <slot>Select files</slot>
      </vue-upload-component>
      <slot name="buttons">
        <button
          type="button"
          class="button cancel"
          @click.prevent="$refs.uploadPrincipal.clear()"
        >
          Clear list
        </button>
        <button
          v-if="uploaded"
          type="button"
          class="button"
          @click.prevent="$refs.uploadPrincipal.active = false"
        >
          Uploaded
        </button>
        <button
          v-else-if="$refs.uploadPrincipal && !$refs.uploadPrincipal.active"
          type="button"
          class="button"
          @click.prevent="$refs.uploadPrincipal.active = true"
        >
          Start Upload
        </button>

        <button
          v-else
          type="button"
          class="button warning"
          @click.prevent="$refs.uploadPrincipal.active = false"
        >
          Stop Upload
        </button>
      </slot>
    </div>
  </div>
</template>

<script>
import VueUploadComponent from "vue-upload-component";

export default {
  name: "FotoPrincipal",
  components: {
    VueUploadComponent
  },
  props: {
    idProducto: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      filesPrincipal: [],
      active: false,
      uploaded: false
    };
  },
  watch: {
    filesCatalogo() {
      if (this.active !== this.$refs.uploadPrincipal.active) {
        this.active = this.$refs.uploadPrincipal.active;
        this.$emit("uploading", this.active);
      }
      if (this.uploaded !== this.$refs.uploadPrincipal.uploaded) {
        this.uploaded = this.$refs.uploadPrincipal.uploaded;
        this.$emit("uploaded", this.uploaded);
      }
    }
  },
  computed: {
    logotipoAPI: {
      get() {
        return `${this.$store.state.api.url}set-foto-principal?id=${this.idProducto}`;
      }
    }
  },
  methods: {
    removeImage(file) {
      this.$refs.uploadPrincipal.remove(file);
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Before adding a file
        // Filter system files or hide files
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }
      }
      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        // Create a blob field
        newFile.blob = "";
        let URL = window.URL || window.webkitURL;
        if (URL && URL.createObjectURL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }
        // Thumbnails
        newFile.thumb = "";
        if (newFile.blob && newFile.type.substr(0, 6) === "image/") {
          newFile.thumb = newFile.blob;
        }
      }
    },
    inputFile(newFile, oldFile) {
      if (newFile && !oldFile) {
        // add
        console.log("add", newFile);
      }
      if (newFile && oldFile) {
        // Start upload
        if (newFile.active !== oldFile.active) {
          console.log("Start upload", newFile.active, newFile);
        }

        // Upload progress
        if (newFile.progress !== oldFile.progress) {
          console.log("progress", newFile.progress, newFile);
        }

        // Upload error
        if (newFile.error !== oldFile.error) {
          console.log("error", newFile.error, newFile);
        }

        // Uploaded successfully
        if (newFile.success !== oldFile.success) {
          console.log("success", newFile.success, newFile);
          console.log(newFile.response);
          this.removeImage(newFile);
          this.$store.commit("SET_FOTO_PRINCIPAL", newFile.response.name);
        }
      }
      if (!newFile && oldFile) {
        // remove
        console.log("remove", oldFile);
      }
    },
    formatSize(size) {
      if (size > 1024 * 1024 * 1024 * 1024) {
        return (size / 1024 / 1024 / 1024 / 1024).toFixed(2) + " TB";
      } else if (size > 1024 * 1024 * 1024) {
        return (size / 1024 / 1024 / 1024).toFixed(2) + " GB";
      } else if (size > 1024 * 1024) {
        return (size / 1024 / 1024).toFixed(2) + " MB";
      } else if (size > 1024) {
        return (size / 1024).toFixed(2) + " KB";
      }
      return size.toString() + " B";
    }
  }
};
</script>

<style scoped>
.rokka-uploader h4 {
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
}
.rokka-uploader .p-5 {
  padding: 2rem !important;
  border: 1px solid;
  margin-bottom: 5px;
}
.rokka-uploader .drop-active {
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  position: fixed;
  z-index: 9999;
  opacity: 0.6;
  text-align: center;
  background: #000;
}
.rokka-uploader .thumb {
  max-width: 80px;
}
.rokka-uploader .thumb img {
  max-width: 80px;
  max-height: 60px;
  margin-left: auto;
  margin-right: auto;
  display: block;
}
.rokka-uploader .biggerPreview {
  position: fixed;
  left: 15vw;
  z-index: 100;
  max-width: 100%;
  max-height: 80%;
  perspective: 0;
  backface-visibility: hidden;
  will-change: transform;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.5);
}

.rokka-uploader .button,
.rokka-uploader .rokka-fileupload {
  margin-right: 5px;
  padding: 5px;
  background-color: transparent;
  border: 1px solid;
  display: inline-block;
  vertical-align: middle;
  font-size: 16px;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
}
</style>
